import { ConfigProvider, Shell } from '@alifd/next';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Button, ConfigProvider as AntConfigProvider } from 'antd';
import zh_TW from 'antd/lib/locale/zh_TW';
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';

import { BackStageContext } from '@/contexts/BackStageContext';
import FetchUserData from '@/redux/FetchUserData';

import client from '../../lib/feathers';
import styles from './BasicLayout.module.scss';
import Footer from './components/Footer';
import HeaderAvatar from './components/HeaderAvatar';
import Logo from './components/Logo';
// import GlobalSearch from './components/GlobalSearch';
import Notice from './components/Notice';
import PageNav from './components/PageNav';

const theme = createTheme({
  palette: {
    primary: {
      main: '#209bfa',
      dark: '#1274e7',
    },
  },
});

(function () {
  const throttle = function (type, name, obj = window) {
    let running = false;

    const func = () => {
      if (running) {
        return;
      }

      running = true;
      requestAnimationFrame(() => {
        obj.dispatchEvent(new CustomEvent(name));
        running = false;
      });
    };

    obj.addEventListener(type, func);
  };

  if (typeof window !== 'undefined') {
    throttle('resize', 'optimizedResize');
  }
})();

export default function BasicLayout({ children }) {
  const [currentNav, setCurrentNav] = useState(null);
  const [backStageUpdateTrigger, setBackStageUpdateTrigger] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [packageInfo, setPackageInfo] = useState({});
  const [task, setTask] = useState('');
  const [urgent, setUrgent] = useState(null);
  const [urgentPopup, setUrgentPopup] = useState(false);
  const audRef = useRef(null);
  const btnRef = useRef(null);
  useEffect(() => {
    (async () => {
      try {
        const data = await client.reAuthenticate();
        const show = data?.user.allow.find((i) => i.name === '送件服務');
        if (show) {
          client.io.on('robotStatus', (arr, callback) => {
            console.log('robotStatus msg:', arr);
            if (arr.position === 'guardHouse') {
              setShowPopup(arr.task === 'closeDoor' ? false : true);
              setPackageInfo(arr.package);
              setTask(arr.task);
              callback('success');
            }
          });
        }
        client.io.on('baEvent', (arr) => {
          setUrgent(arr);
          setUrgentPopup(true);
          setTimeout(() => {
            setUrgentPopup(false);
            audRef.current.pause();
          }, arr?.urgentTime);
          if (audRef.current && btnRef.current) {
            btnRef.current.click();
          }
        });
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  const getDevice = (width) => {
    const isPhone =
      typeof navigator !== 'undefined' &&
      navigator &&
      navigator.userAgent.match(/phone/gi);

    // console.log(isPhone)
    if (width < 680 || isPhone) {
      return 'phone';
    }
    if (width < 1280 && width > 680) {
      return 'tablet';
    }
    return 'desktop';
  };

  const [device, setDevice] = useState(getDevice(NaN));
  // console.log(device);
  if (typeof window !== 'undefined') {
    window.addEventListener('optimizedResize', (e) => {
      const deviceWidth = (e && e.target && e.target.innerWidth) || NaN;
      setDevice(getDevice(deviceWidth));
    });
  }

  const handleChildClick = (keys) => {
    // 子物件(SubNav點擊事件)傳來事件
    // console.log('DDD',device);//phone/desktop
    if (Array.isArray(keys)) {
      if (keys.length > 0) {
        // 展開SubNav
        setCurrentNav(false); // 展開Navbar (設定Navbar不能縮小)
      } else {
        // 縮小SubNav
        setCurrentNav(null); // (取消設定Navbar參數:自由縮放)
      }
    } else if (typeof keys === 'string' && device === 'phone') {
      setCurrentNav(true); // 手機版點擊NavItem (設定Navbar縮小)
    }
  };

  return (
    <AntConfigProvider locale={zh_TW}>
      <BackStageContext.Provider
        value={{
          setBackStageUpdateTrigger,
          backStageUpdateTrigger,
        }}
      >
        <ThemeProvider theme={theme}>
          <FetchUserData>
            <div className={styles.BasicLayout}>
              <ConfigProvider device={device}>
                <Shell
                  type="brand"
                  style={{
                    minHeight: '100vh',
                  }}
                >
                  <Shell.Branding>
                    <Logo
                      url="/ezpro/home"
                      image="/ezcon/ezcon_logo.png"
                      // image="https://i.ibb.co/r515rq8/logo.png"
                      // text
                    />
                  </Shell.Branding>
                  {/* <Shell.Navigation
            direction="hoz"
            style={{
              marginRight: 10,
            }}
          >
            <GlobalSearch />
          </Shell.Navigation> */}
                  <Shell.Action>
                    <Notice />
                    {/* <SolutionLink /> */}
                    <HeaderAvatar />
                  </Shell.Action>
                  <Shell.Navigation
                    collapse={currentNav} // 參數for [false = Navbar不能縮小(展開)]
                    onCollapseChange={() => {
                      // Navbar展開(點擊左上角觸發)
                      setCurrentNav(null); // (取消設定Navbar參數:自由縮放)
                    }}
                  >
                    <PageNav
                      setNav={handleChildClick}
                      closeNavItem={currentNav}
                    />
                  </Shell.Navigation>

                  <Shell.Content>{children}</Shell.Content>
                  <Shell.Footer>
                    <Footer />
                  </Shell.Footer>
                </Shell>
              </ConfigProvider>
            </div>
          </FetchUserData>
        </ThemeProvider>
        {/* 機器人派送 */}
        <div
          className={styles.BasicLayoutAlert}
          style={{
            display: showPopup ? 'flex' : 'none',
            alignItems: showPopup && 'center',
            justifyContent: showPopup && 'center',
          }}
        >
          <div className={styles.BasicLayoutContainer}>
            {task === 'finish' ? (
              <>
                <img src="icon/送件服務.svg" alt="圖片" />
                <p>
                  {packageInfo.household}住戶
                  {packageInfo?.packageType ? '郵件包裹' : '寄物'}送件完成
                </p>
              </>
            ) : (
              <>
                <img src="img/robot_one.svg" alt="圖片" />
                <p>機器人已到達管理室</p>
                <p>
                  請將{packageInfo.household}住戶編號{packageInfo.order}
                  {packageInfo?.packageType ? '郵件包裹' : '寄物'}放至1號艙
                </p>
                <Button
                  className={styles.robotBtn}
                  onClick={async () => {
                    const result = await Swal.fire({
                      title: `確定已將${packageInfo.household}住戶編號${
                        packageInfo.order
                      }${
                        packageInfo?.packageType ? '郵件包裹' : '寄物'
                      }放至1號艙？`,
                      text: '按下確認後艙門即將關閉，將無法取消送件任務!!',
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#BEBEBE',
                      confirmButtonText: '確定',
                      cancelButtonText: '取消',
                    });
                    if (result.isConfirmed) {
                      Swal.fire('成功!', '機器人派送中', 'success');
                      setShowPopup(false);
                      axios.post(
                        '/ezcon/api/robot/closeGate',
                        {
                          packageInfo: packageInfo,
                          packageTypeName: packageInfo?.packageType
                            ? 'postalRegistration'
                            : 'deposit',
                        },
                        {
                          headers: {
                            authorization: localStorage.getItem('feathers-jwt'),
                          },
                        }
                      );
                    }
                  }}
                >
                  送件
                </Button>
              </>
            )}
          </div>
        </div>
        {/* 緊急訊息 */}
        <div
          className={styles.BasicLayoutBAAlert}
          style={{
            display: urgentPopup ? 'flex' : 'none',
            alignItems: urgentPopup && 'center',
            justifyContent: urgentPopup && 'center',
          }}
        >
          {urgent && (
            <>
              <audio
                src={`/ezcon/uploads/broadcast/${urgent?.text}.mp3`}
                autoPlay
                ref={audRef}
                loop="loop"
              />
              <button
                style={{ display: 'none' }}
                ref={btnRef}
                onClick={() => {
                  console.log(audRef.current);
                  // audRef.current.play();
                  setTimeout(() => {
                    audRef.current.play();
                  }, 1000);
                }}
              >
                按下
              </button>
            </>
          )}

          <marquee direction="left" width="100%">
            <div style={{ fontSize: 50 }}>{urgent?.text}</div>
          </marquee>
        </div>
      </BackStageContext.Provider>
    </AntConfigProvider>
  );
}
